import { List, Switch, message, Flex } from "antd";
import React, { useState } from "react";
import CustomParagraph from "../../components/CustomParagraph";
import CustomInput from "../../components/CustomInput";
import CustomButton from "../../components/CustomButton";
import { useSpin } from "../../components/SpinContext";
import { ShareShipmentApi } from "../../api's/shipment";

function ShareShipment({ shipmentId, token }) {
  const { showSpin, hideSpin } = useSpin();

  const generateNewUUID = () => crypto.randomUUID();

  const [uuid, setUuid] = useState(generateNewUUID());
  const [password, setPassword] = useState("");

  const baseShareLink = `${process.env.REACT_APP_BASE_URL}share/shipment/external-view/${shipmentId}/${uuid}`;
  const [shareLink, setShareLink] = useState(baseShareLink);

  const [list, setList] = useState([
    {
      name: "Show product details",
      key: "showProductDetails",
      checked: false,
      disabled: true,
    },
    {
      name: "Show alerts",
      key: "showAlerts",
      checked: false,
      disabled: true,
    },
    {
      name: "Require password",
      key: "requirePassword",
      checked: false,
    },
  ]);

  const toggleSwitch = (index) => {
    const newList = [...list];
    newList[index].checked = !newList[index].checked;

    const isRequirePasswordIndex = newList.findIndex(
      (item) => item.key === "requirePassword"
    );
    const isProductDetailsIndex = newList.findIndex(
      (item) => item.key === "showProductDetails"
    );
    const isAlertsIndex = newList.findIndex(
      (item) => item.key === "showAlerts"
    );

    if (newList[index].key === "requirePassword") {
      const requirePasswordEnabled = newList[index].checked;
      setPassword("");
      newList.forEach((item) => {
        if (item.key !== "requirePassword") {
          item.disabled = !requirePasswordEnabled;
          if (!requirePasswordEnabled) {
            item.checked = false;
          }
        }
      });

      const newUuid = generateNewUUID();
      setUuid(newUuid);
      setShareLink(
        `${process.env.REACT_APP_BASE_URL}share/shipment/external-view/${shipmentId}/${newUuid}`
      );
    } else if (
      newList[index].key === "showProductDetails" ||
      newList[index].key === "showAlerts"
    ) {
      if (!newList[isRequirePasswordIndex].checked) {
        newList[isRequirePasswordIndex].checked = true;
        newList.forEach((item) => {
          if (item.key !== "requirePassword") {
            item.disabled = false;
          }
        });
      }
      if (
        !newList[isProductDetailsIndex].checked &&
        !newList[isAlertsIndex].checked
      ) {
        newList[isRequirePasswordIndex].checked = false;
        newList.forEach((item) => {
          if (item.key !== "requirePassword") {
            item.disabled = true;
            item.checked = false;
          }
        });
      }
    }

    setList(newList);
  };

  // const handleCopy = () => {
  //   debugger
  //   navigator.clipboard.writeText(shareLink)
  //     .then(() => {
  //       debugger
  //       message.success("Link copied to clipboard!");
  //       const newUuid = generateNewUUID();
  //       setUuid(newUuid);
  //       setShareLink(
  //         `${process.env.REACT_APP_BASE_URL}share/shipment/external-view/${shipmentId}/${newUuid}`
  //       );
  //     })
  //     .catch((err) => {
  //       debugger
  //       console.error("Clipboard error:", err);
  //       fallbackCopyTextToClipboard(shareLink); // Add fallback for Safari
  //     });
  // };

  // const  fallbackCopyTextToClipboard = (text)=> {
  //   debugger
  //   const textArea = document.createElement("textarea");
  //   textArea.value = text;
  //   textArea.style.position = "fixed";
  //   textArea.style.top = 0;
  //   textArea.style.left = 0;
  //   textArea.style.opacity = "0";
  //   document.body.appendChild(textArea);
  //   textArea.focus();
  //   textArea.select();

  //   try {
  //     debugger
  //     const successful = document.execCommand("copy");
  //     if (successful) {
  //       debugger
  //       message.success("Link copied using fallback!");
  //     } else {
  //       debugger
  //       message.error("Copy failed. Please copy manually.");
  //     }
  //   } catch (err) {
  //     console.error("Fallback copy failed:", err);
  //     message.error("Copy failed. Please copy manually.");
  //   }
  //   debugger
  //   document.body.removeChild(textArea);
  // }


  const handleCopyLink = (newUuid) => {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard
        .writeText(shareLink)
        .then(() => {
          message.success("Link copied to clipboard!");
          const newUuid = generateNewUUID();
          setUuid(newUuid);
          setShareLink(
            `${process.env.REACT_APP_BASE_URL}share/shipment/external-view/${shipmentId}/${newUuid}`
          );
          // setShareLink(
          //   `${process.env.REACT_APP_BASE_URL}share/shipment/external-view/${shipmentId}/${uuid}`
          // );
        })
        .catch(() => fallbackCopyToClipboard(shareLink));
    } else {
      fallbackCopyToClipboard(shareLink);
    }
  };

  const fallbackCopyToClipboard = (text) => {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed"; // prevent scrolling to bottom
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    try {
      document.execCommand("copy");
      message.success("Link copied to clipboard!");
    } catch (err) {
      message.error("Copy failed. Please copy manually.");
    }

    document.body.removeChild(textarea);
  };


  const copyToClipboard = () => {
    const requirePassword = list.find(
      (item) => item.key === "requirePassword"
    )?.checked;
    const showProductDetails = list.find(
      (item) => item.key === "showProductDetails"
    )?.checked;
    const showAlerts = list.find((item) => item.key === "showAlerts")?.checked;

    if (requirePassword) {
      if (!password) {
        message.error("Please enter a password before copying the link.");
        return;
      }
      if (password.length < 6) {
        message.error("Password must be at least 6 characters long.");
        return;
      }
    }

    const newUuid = generateNewUUID();
    // setUuid(newUuid);

    const payload = {
      shipment: shipmentId,
      show_product_details: showProductDetails,
      show_alerts: showAlerts,
      require_password: requirePassword,
      password: requirePassword ? password : null,
      token: uuid,
    };




    showSpin();
    ShareShipmentApi(token, payload)
      .then((res) => {
        const data = res?.data || null;
        if (data) {
          if (data?.data?.is_success) {
            setTimeout(() => {
              handleCopyLink(newUuid);
            }, 300)
            // navigator.clipboard.writeText(shareLink).then(() => {
            //   message.success("Link copied to clipboard!");
            //   const newUuid = generateNewUUID();
            //   setUuid(newUuid);
            //   setShareLink(
            //     `${process.env.REACT_APP_BASE_URL}share/shipment/external-view/${shipmentId}/${newUuid}`
            //   );
            // });
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch(() => {
        message.error("Error while generating the shareable link.");
      })
      .finally(() => {
        hideSpin();
      });
  };

  return (
    <>
      <List
        className="custom-list-container"
        itemLayout="horizontal"
        dataSource={list}
        renderItem={(item, index) => (
          <List.Item className="custom-radio-list-item">
            <CustomParagraph
              text={item.name}
              fontSize={14}
              fontWeight={400}
              lineHeight="20px"
              color="#000"
              marginBottom={0}
            />

            <Switch
              checked={item.checked}
              onChange={() => toggleSwitch(index)}
              style={{ marginLeft: "10px" }}
            />
          </List.Item>
        )}
        style={{ margin: "0 0 12px" }}
      ></List>

      {list.find((item) => item.key === "requirePassword")?.checked && (
        <div style={{ marginBottom: "20px" }}>
          {" "}
          <CustomInput
            placeholder="Set password you'll share to open the tracking link"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            height={36}
            marginBottom={12}
            fontSize={14}
            lineHeight="20px"

          />
        </div>
      )}

      <Flex justify="space-between" gap={16}>
        <CustomInput
          value={shareLink}
          disabled
          bgColor="#F3F3F3"
          borderRadius={8}
          height={36}
          marginBottom={0}
          border="none"
          fontSize={14}
          lineHeight="20px"
          color="#000"
        />

        <CustomButton
          onClick={copyToClipboard}
          text="Copy Link"
          height={36}
          width={85}
          fontSize={14}
          fontWeight="500"
          color="#fff"
          bgColor="#000"
        />
      </Flex>
    </>
  );
}

export default ShareShipment;
